/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const progressDataSchema = z.object({
  total: z.number(),
  reviewed: z.number(),
});

export const getCollectionTriageProgressResponseSchema = createApiResponseSchema(
  progressDataSchema,
) as z.ZodSchema<IAPI<ITriageProgress>>;

export interface ITriageProgress {
  total: number;
  reviewed: number;
}

export type IGetCollectionTriageProgressResponse = IAPI<ITriageProgress>;
